<div class="row">
    <div class="col-sm-9"></div>
    <div class="col-sm-3 vid-actions-menu">
        <button *ngIf="identity?.status === 'BLOCKED'" id="unblockIdentityBtn" (click)="onUnblockIdentity()" type="button" class="float-end vid-btn vid-btn-red vid-btn-sm ms-2">{{ 'IDENTITY.UNBLOCK_IDENTITY_BTN' | translate }}</button>
        <button *ngIf="!hideRemoveIdentityButton" id="removeIdentityBtn" (click)="onRemoveIdentity()" type="button" class="float-end vid-btn vid-btn-red vid-btn-sm ms-2">{{ 'IDENTITY.REMOVE' | translate }}</button>
    </div>
</div>

<div class="row" *ngIf="identity">
    <div class="col-sm-10">
        <div class="vid-main-content">

            <div class="row col-sm-12">

                <div class="vid-card vid-card-lg">
                    <h5 class="card-title">{{ 'IDENTITY.VERIDIUM_DETAILS' | translate }}</h5>

                    <div>
                        <div class="vid-card-label">{{ 'AUTHENTICATORS.STATUS' | translate }}:</div>
                        <div class="vid-card-value">
                            <div [ngSwitch]="identity.status">
                                <span *ngSwitchCase="'ACTIVE'"
                                    class="vid-badge badge bg-success ng-star-inserted">{{identity.status}}</span>
                                <span *ngSwitchDefault
                                    class="vid-badge badge bg-secondary ng-star-inserted">{{identity.status}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="mt-2">
                        <div class="vid-card-label">{{ 'IDENTITY.ID' | translate }}:</div>
                        <div class="vid-card-value">{{identity.id}}</div>
                    </div>


                    <div class="mt-2">
                        <div class="vid-card-label">{{ 'IDENTITY.NAME' | translate }}:</div>
                        <div class="vid-card-value">{{identity.displayName}}</div>
                    </div>


                    <div class="mt-2">
                        <div class="vid-card-label">{{ 'IDENTITY.REG_TIME' | translate }}:</div>
                        <div class="vid-card-value">
                          {{identity.registrationTime | isoDateTime}}
                        </div>
                    </div>


                </div>

                <div class="vid-card vid-card-lg">
                    <h5 class="card-title">{{ 'IDENTITY.EXT_DETAILS' | translate }}</h5>

                    <div class="mt-2" *ngIf="identity.firstName">
                        <div class="vid-card-label">{{ 'IDENTITY.FNAME' | translate }}:</div>
                        <div class="vid-card-value">{{identity.firstName}}</div>
                    </div>

                    <div class="mt-2" *ngIf="identity.lastName">
                        <div class="vid-card-label">{{ 'IDENTITY.LNAME' | translate }}:</div>
                        <div class="vid-card-value">{{identity.lastName}}</div>
                    </div>

                    <div class="mt-2">
                        <div class="vid-card-label">{{ 'IDENTITY.EXT_ID' | translate }}:</div>
                        <div class="vid-card-value">{{identity.externalId}}</div>
                    </div>

                    <div class="mt-2">
                        <div class="vid-card-label">{{ 'IDENTITY.EMAIL' | translate }}:</div>
                        <div class="vid-card-value">{{identity.emailAddress}}</div>
                    </div>

                    <div class="mt-2" *ngIf="identity.phoneNumber">
                        <div class="vid-card-label">{{ 'IDENTITY.PHONE' | translate }}:</div>
                        <div class="vid-card-value">{{identity.phoneNumber}}</div>
                    </div>

                    <div class="mt-2" *ngIf="identity.customPhoneNumber">
                        <div class="vid-card-label">{{ 'IDENTITY.CUSTOM_PHONE' | translate }}:</div>
                        <div class="vid-card-value">{{identity.customPhoneNumber}}</div>
                    </div>

                    <div class="mt-2" *ngIf="identity.upn">
                        <div class="vid-card-label">{{ 'IDENTITY.UPN' | translate }}:</div>
                        <div class="vid-card-value">{{identity.upn}}</div>
                    </div>

                    <div class="mt-2" *ngIf="identity.groups">
                        <div class="vid-card-label">{{ 'IDENTITY.GROUPS' | translate }}</div>
                        <div class="vid-card-value">{{identity.groups}}</div>
                    </div>

                </div>

                <div class="vid-card vid-card-lg">
                    <h5 class="card-title">{{ 'IDENTITY.INTEGRATION_DETAILS' | translate }}</h5>

                    <div class="mt-2" *ngIf="identity.integrationName">
                        <div class="vid-card-label">{{ 'IDENTITY.INTEGRATION_NAME' | translate }}:</div>
                        <div class="vid-card-value">{{identity.integrationName}}</div>
                    </div>

                    <div class="mt-2" *ngIf="identity.integrationDescription">
                        <div class="vid-card-label">{{ 'IDENTITY.INTEGRATION_DESC' | translate }}:</div>
                        <div class="vid-card-value">{{identity.integrationDescription}}</div>
                    </div>

                    <div class="mt-2" *ngIf="identity.integrationExternalId">
                        <div class="vid-card-label">{{ 'IDENTITY.INTEGRATION_EXT_ID' | translate }}:</div>
                        <div class="vid-card-value">{{identity.integrationExternalId}}</div>
                    </div>

                </div>
            </div>

        </div>
    </div>

    <div class="col-sm-2">
        <div class="vid-right-side-menu vid-side-menu-no-top">
            <div class="mb-2 p-2">
                <span class="section-title">{{ 'IDENTITY.HELP' | translate }}</span>
                <div class="settings-activity">

                    <div class="m-2 alert alert-secondary vid-list-item-description" role="alert">
                        {{ 'IDENTITY.HELP_ABOUT' | translate }}
                    </div>

                    <div class="m-2 alert alert-secondary vid-list-item-description" role="alert">
                        {{ 'IDENTITY.HELP_REMOVE' | translate }}
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
